import { Card, Col, Divider, Form, Input, Button, Row, Select, message } from "antd";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import ConsultHeaderCard from "../../../components/Common/Cards/ConsultHeaderCard";
import { filterOption, isValidValue, setFormFieldValue } from "../../../helpers/FormHelper";
import { getErrorMessage } from "../../../helpers/ErrorHelper";
import { useSelector } from "react-redux";
import { capitalizeFirstLetter, lowerCaseString } from "../../../helpers/StringFormatter";
import moment from "moment";
import ErrorAlertModal from "../../../components/Common/Modals/ErrorAlertModal";
import VHPService from "../../../services/VHP/VHPService";



const rules = {
    preference: [
        {
            required: true,
            message: "Ju lutem zgjidhni preferencën politike!",
        },
    ],
    safety: [
        {
            required: true,
            message: "Ju lutem zgjidhni sigurinë e votuesit!",
        },
    ],
    phone: [
        {
            required: false,
            message: "Ju lutem plotësoni numrin e telefonit!",
        },
    ],
    email: [
        {
            required: false,
            message: "Ju lutem plotësoni email!",
        },
        {
            type: "email",
            message: "Ju lutem jepni një email të vlefshëm!",
        }
    ],
    comment: [
        {
            required: false,
            message: "Ju lutem plotësoni komentet!",
        },
    ]
};



const Edit = ({ item, preferences, onBack, onSuccess }) => {
    const token = useSelector((state) => state.Member.token);
    const [errorMessage, setErrorMessage] = useState(null);
    const [errorModal, setErrorModal] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [form] = Form.useForm();


    useEffect(() => {
        form.setFieldsValue({
            name: setFormFieldValue(item?.voter?.name),
            surname: setFormFieldValue(item?.voter?.surname),
            father_name: setFormFieldValue(item?.voter?.father_name),
            birthdate: isValidValue(item?.voter?.dob) ? moment(item?.voter?.dob).format("DD-MM-YYYY") : null,
            gender: setFormFieldValue(item?.voter?.gender),
            qv: setFormFieldValue(item?.voter?.qv?.code),
            preference: setFormFieldValue(item?.political_preference?.id),
            safety: item?.safety_rating === 0 ? null : setFormFieldValue(item?.safety_rating),
            email: setFormFieldValue(item?.email),
            phone: setFormFieldValue(item?.phone),
            comment: setFormFieldValue(item?.comment),
        });
    }, [form, item]);


    const formatRequestData = (data) => {
        return {
            political_preference_id: setFormFieldValue(data?.preference),
            safety_rating: setFormFieldValue(data?.safety),
            email: lowerCaseString(data?.email),
            phone: setFormFieldValue(data?.phone),
            comment: capitalizeFirstLetter(data?.comment),
        };
    };


    const onUpdate = async () => {
        try {
            setSubmitLoading(true);
            const data = await form.validateFields();
            const requestData = formatRequestData(data);
            const voterId = setFormFieldValue(item?.id);
            const response = await VHPService.updatePreference(token, requestData, voterId);
            const responseData = response.data;
            if (responseData) {
                await message.success('Referenca u modifikua me sukses!', 1);
                setErrorMessage(null);
                onSuccess();
            } else {
                const errorMessage = 'Një gabim ndodhi gjatë modifikimit të referencës!';
                setErrorMessage(errorMessage);
                setErrorModal(true);
            }
        } catch (error) {
            if (error?.values) {
                setSubmitLoading(false);
                return;
            }
            const errorMessage = getErrorMessage(error);
            setErrorMessage(errorMessage);
            setErrorModal(true);
        } finally {
            setSubmitLoading(false);
        }
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24} className="mb-3">
                    <Col span={24}>
                        <ConsultHeaderCard
                            longTitle="Jeni duke modifikuar preferencën VHP"
                            shortTitle="Preferenca VHP"
                            onBack={onBack}
                        />
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card style={{ borderRadius: "0" }}>
                            <Form form={form} labelAlign="left" labelCol={{ span: 7 }} layout="horizontal">
                                <Row gutter={24}>
                                    <Col span={24}>
                                        {/* VOTER */}
                                        <Row gutter={24}>
                                            <Col span={24}>
                                                <Row gutter={24}>
                                                    <Col span={24}>
                                                        <h5 className="font-weight-bold">
                                                            Të dhënat e votuesit
                                                        </h5>
                                                    </Col>
                                                    <Col span={24}>
                                                        <Divider className="w-100 mt-0" />
                                                    </Col>
                                                </Row>
                                                <Row gutter={24} align="top" className="m-0">
                                                    <Col xl={11} lg={11} md={24} sm={24} xs={24}>
                                                        <Form.Item name="name" label="Emri" rules={rules.voter}>
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="surname" label="Mbiemri" rules={rules.voter}>
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="father_name" label="Atësia">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xl={2} lg={2} md={24} sm={24} xs={24} />
                                                    <Col xl={11} lg={11} md={24} sm={24} xs={24}>
                                                        <Form.Item name="birthdate" label="Datëlindja">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="gender" label="Gjinia">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                        <Form.Item name="qv" label="QV">
                                                            <Input type="text" disabled />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        {/* EMIGRANT */}
                                        <Row gutter={24} className="mt-4">
                                            <Col span={24}>
                                                <Row gutter={24}>
                                                    <Col span={24}>
                                                        <h5 className="font-weight-bold">
                                                            Të dhëna shtesë
                                                        </h5>
                                                    </Col>
                                                    <Col span={24}>
                                                        <Divider className="w-100 mt-0" />
                                                    </Col>
                                                </Row>
                                                <Row gutter={24} className="m-0">
                                                    <Col xl={11} lg={11} md={24} sm={24} xs={24}>
                                                        <Form.Item name="preference" label="Preferenca politike" rules={rules.preference}>
                                                            <Select
                                                                showSearch
                                                                optionLabelProp="children"
                                                                filterOption={filterOption}
                                                                placeholder="-Zgjidhni opsionin-"
                                                            >
                                                                {preferences?.map((item) => (
                                                                    <Select.Option key={item?.id} value={item?.id}>
                                                                        {item?.name}
                                                                    </Select.Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                        <Form.Item name="safety" label="Siguria e votuesit" rules={rules.safety}>
                                                            <Select
                                                                showSearch
                                                                optionLabelProp="children"
                                                                filterOption={filterOption}
                                                                placeholder="-Zgjidhni opsionin-"
                                                            >
                                                                <Select.Option key="1" value={1}>I sigurtë</Select.Option>
                                                                <Select.Option key="2" value={2}>I pasigurtë</Select.Option>
                                                                <Select.Option key="3" value={3}>I lëkundur</Select.Option>
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xl={2} lg={2} md={24} sm={24} xs={24} />
                                                    <Col xl={11} lg={11} md={24} sm={24} xs={24}>
                                                        <Form.Item name="email" label="Email:" rules={rules.email}>
                                                            <Input type="text" placeholder="Email..." />
                                                        </Form.Item>
                                                        <Form.Item name="phone" label="Telefoni:" rules={rules.phone}>
                                                            <Input type="text" placeholder="Telefoni..." />
                                                        </Form.Item>
                                                        <Form.Item name="comment" label="Komente:" rules={rules.comment}>
                                                            <Input.TextArea placeholder="Komente..." type="text" rows={4} />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row gutter={24}>
                                    <Col span={24}>
                                        <Divider className="w-100" />
                                    </Col>
                                </Row>
                                <Row gutter={24} className="p-2">
                                    <Col xl={8} lg={8} md={4} sm={0} xs={0} />
                                    <Col xl={4} lg={4} md={8} sm={12} xs={12}>
                                        <Button
                                            block
                                            type="primary"
                                            loading={submitLoading}
                                            style={{ height: "37px" }}
                                            icon={<CheckOutlined />}
                                            onClick={onUpdate}
                                        >
                                            Ruaj
                                        </Button>
                                    </Col>
                                    <Col xl={4} lg={4} md={8} sm={12} xs={12}>
                                        <Button
                                            block
                                            danger
                                            disabled={submitLoading}
                                            style={{ height: "37px" }}
                                            icon={<CloseOutlined />}
                                            onClick={onBack}
                                        >
                                            Mbyll
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <ErrorAlertModal
                            isOpen={errorModal}
                            title={errorMessage}
                            subtitle="Modifiko pereferencën e VHP"
                            onClose={() => setErrorModal(false)}
                            onConfirm={() => setErrorModal(false)}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default Edit;